// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1y-q";
export var animationRelative = "_1y-p";
export var backdropBlur = "_1y-0";
export var detailLabelCell = "_1y-12";
export var detailTable = "_1y-11";
export var detailValueCell = "_1y-13";
export var docIconBox = "_1y-1d";
export var docIconBoxMd = "_1y-1f";
export var docIconBoxSm = "_1y-1e";
export var docTypeRow = "_1y-16";
export var docTypeRowInner = "_1y-17";
export var dropdownMatchDatePicker = "_1y-3";
export var evidenceCardContent = "_1y-1c";
export var fileUploadSpin = "_1y-j";
export var gorgiasOpenButton = "_1y-15 _1y-d";
export var gorgiasTicketCard = "_1y-14";
export var heroModalFooterButton = "_1y-18";
export var hiddenContainer = "_1y-o";
export var iconPrimary = "_1y-1g";
export var iconQuaternary = "_1y-1i";
export var iconTertiary = "_1y-1h";
export var integrationCard = "_1y-1";
export var integrationLogoBox = "_1y-2";
export var mainColumnSticky = "_1y-1b";
export var maxWidthContainer = "_1y-19";
export var modalContentBody = "_1y-a";
export var modalHeaderImage = "_1y-5";
export var modalImageLabel = "_1y-7";
export var modalImageOverlay = "_1y-6";
export var modalImageSubtitle = "_1y-9";
export var modalImageTitle = "_1y-8";
export var modalImageWrapper = "_1y-4";
export var modalStickyFooter = "_1y-b";
export var removeButton = "_1y-e";
export var sidebarColumn = "_1y-1a";
export var spinner = "_1y-i";
export var timelineLine = "_1y-y";
export var timelineLineBlack = "_1y-10 _1y-y";
export var timelineLineGray = "_1y-z _1y-y";
export var timelineLineHeight = "_1y-x";
export var tlDotActivate = "_1y-u";
export var tlDotActivateAnim = "_1y-t";
export var tlDotHide = "_1y-s";
export var tlDotHideAnim = "_1y-r";
export var tlLineActivate = "_1y-w";
export var tlLineActivateAnim = "_1y-v";
export var uploadHint = "_1y-n";
export var uploadIconBox = "_1y-k";
export var uploadLabel = "_1y-m";
export var uploadText = "_1y-l";
export var uploadZone = "_1y-f";
export var uploadZoneCursorDefault = "_1y-h";
export var uploadZoneCursorPointer = "_1y-g";
export var uploadedFileRow = "_1y-c";
export var viewButton = "_1y-d";